/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import 'cross-fetch';
 
const HOST = process.env.REACT_APP_API_URL + '/';

export const GET_REQUEST = HOST + 'configuration/{id}';
export const POST_REQUEST = HOST + 'configuration/{id}';
export const SEND_REQUEST = HOST + 'configuration/send-request/{id}';
export const GET_LIBRARY = HOST + 'data';
export const GET_LOGO = HOST + 'configuration/{id}/logo/{filename}';
export const DELETE_LOGO = HOST + 'configuration/{id}/logo/{filename}';
export const POST_LOGO = HOST + 'configuration/{id}/logo';

export function getURL(baseURL: string, parameters: any) : string {
    let finalUrl = baseURL;
    
    Object.keys(parameters).forEach(function(key,index) {
        finalUrl = finalUrl.replace('{' + key + '}', parameters[key]);
    });

    return finalUrl;
}

export function fetchAPI(dispatch: any, getState: any, url:string, data:object|string = {}, method:string = 'POST', cache:RequestCache | undefined = undefined): Promise<Response> {
    let formData: FormData|string|null = null;
    let headers: Headers = new Headers();
    if(method === 'POST') {
        if (typeof data === 'string' || data instanceof String) {
            formData = data as string;
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
        } else {
            if(data instanceof FormData) {
                formData = data;
            } else {
                formData = new FormData();
                for (const [key, value] of Object.entries(data)) {
                    formData.append(key, value);
                }
            }
        }
    }

    return fetch(url, {
        method,
        credentials: 'include',
        body: formData,
        headers,
        cache
    })
    .then(
        function(response: Response){
            if (response.ok) {
                return response;
            } else {
                let errorText = response.statusText;
                if(response.status === 401 || response.status === 403) {
                    errorText = 'errors.unauthorized';
                }
                if(response.status === 404) {
                    errorText = 'errors.notfound';
                }
                if(errorText === 'Network request failed') {
                    errorText = 'errors.network';
                }

                let error = new Error(errorText);
                throw error;
            }
        }
    );
}